'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z' });

var PermContactCalendar = function PermContactCalendar(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PermContactCalendar = (0, _pure2.default)(PermContactCalendar);
PermContactCalendar.muiName = 'SvgIcon';

exports.default = PermContactCalendar;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PermContactCalendar.js
// module id = 2680
// module chunks = 0